import { fetchApi } from '@/config/axiosSetting.ts';
import { BodyPersonalInformationOwnerResponseType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyOwnerType';

export const getBodyOwnerUserInformationQueryFunction = (
  id: number,
): Promise<BodyPersonalInformationOwnerResponseType> =>
  fetchApi({
    url: `/body/reports/${id}/insurer_information/owner/`,
  });
